import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FwPopoverComponent } from '@flywheel-io/vision';

import { OperationFeedbackItemDownloadStatus } from './operation-feedback.enums';
import { OperationFeedbackItemData } from './operation-feedback.interfaces';

@Component({
  selector: 'operation-feedback',
  templateUrl: './operation-feedback.component.html',
  styleUrls: ['./operation-feedback.component.scss'],
  host: {
    'test-id': 'operation-feedback',
  },
  animations: [
    trigger('toggle', [
      transition(':enter', [style({ height: 0 }), animate('0.15s ease-in', style({ height: '*' }))]),
      transition(':leave', [style({ height: '*' }), animate('0.15s ease-in', style({ height: 0 }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OperationFeedback {
  @Input()
  set items(value: OperationFeedbackItemData[]) {
    this._items = value;
    this.itemsInProgressCount = 0;
    this.finishedItemsCount = 0;
    value.forEach((item: OperationFeedbackItemData) => {
      if (item.status === OperationFeedbackItemDownloadStatus.Progress) {
        this.itemsInProgressCount++;
      } else {
        this.finishedItemsCount++;
      }
    });
  }

  get items(): OperationFeedbackItemData[] {
    return this._items;
  }

  private _items: OperationFeedbackItemData[] = [];

  @Output() close = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<OperationFeedbackItemData>();
  @Output() cancel = new EventEmitter<OperationFeedbackItemData>();

  @ViewChild('popoverTrigger') popoverTrigger: ElementRef;
  @ViewChild(FwPopoverComponent) popover: FwPopoverComponent;

  protected itemsInProgressCount = 1;
  protected finishedItemsCount = 0;
  protected isOpen = false;

  protected closePopover(): void {
    if (!this.popover.isOpen()) {
      return;
    }

    this.popoverTrigger.nativeElement.click();
  }

  protected trackByOperationFeedbackItem(index: number, item: OperationFeedbackItemData): string {
    return item.title + item.start;
  }

  protected onCloseClick(): void {
    if (this.itemsInProgressCount) {
      this.popoverTrigger.nativeElement.click();
      return;
    }

    this.closePopover();
    this.close.emit();
  }
}
